import React, { Component } from "react";
import { UncontrolledTooltip, Badge } from "reactstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import { FaRegCheckSquare } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { fetchData } from "../common/networkRequests";
import { getObjectsValue, calculateInterest, RelevantIcon, goToName } from "../oro-module/commonFunctions";
class CheckboxCustom extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000))
    };
  }
  generateID() {
    return this.state.ttid;
  }

  generateID2() {
    return this.state.ttid2;
  }

  generateOtherValues = (sendData) => {
    let { pageData, openmodals } = this.props.parentState;
    let returnVal = {}
    if (sendData.length != 0) {
      sendData.map(otherfield => {
        if (otherfield.varname) {
          returnVal[otherfield.varname] = getObjectsValue(pageData, otherfield.value);
        } else {
          returnVal[otherfield] = getObjectsValue(pageData, otherfield);
        }
      })
    }
    return returnVal
  }
  setErrorMessages = (errorMessage) => {
    let x = this.props.parentState.errorMessages;
    let { modalname } = this.props.parentState;
    let varname = this.props.component.name;
    if (modalname) {
      if (x[modalname]) {
        errorMessage ? x[modalname][varname] = errorMessage : delete x[modalname][varname]
      } else {
        errorMessage ? x[modalname] = { [varname]: errorMessage } : delete x[varname]
      }
    } else {
      errorMessage ? x[varname] = errorMessage : delete x[varname]
    }
    this.props.liftGlobalState({ name: "errorMessages" }, x);
  }
  handleChange = async (e) => {
    let { sendToServer, displayData, requiredKey, label, onLeave, onClicking, clearData } = this.props.component;
    let x = this.props.parentState.errorMessages;
    x[this.props.component.name] = "";
    this.props.liftGlobalState({ name: "errorMessages" }, x);
    this.props.liftState(this.props.component, e.target.checked);

    if (sendToServer && e.target.checked) {
      let {
        currentPage,
        alerts,
        formElements,
        notifications, remoteip
      } = this.props.parentState;
      let retval = []; let reterr = [];

      let CBSurl = `${remoteip}/sentry`;
      let method = 'post';
      let { dataType, sendData, func } = sendToServer;
      let { token } = this.props.parentProps.parentState;
      let saveThis = { dataType, dependantOnValues: sendData && this.generateOtherValues(sendData), currentPage, name: func };
      let { results, exceptions, vendorErrors, error } = await fetchData({ url: CBSurl, postData: saveThis, method, headers: { Authorization: `JWT ${token}` } });
      reterr = exceptions;


      if (error) {
        this.setErrorMessages("Can not connect to the main server");
        notifications = { value: "Can not connect to the main server", alertType: "warning" };
        this.props.liftGlobalState({ name: 'notifications' }, notifications);
      }
      else if (vendorErrors && vendorErrors.length > 0) {
        notifications = { value: "Can not connect to the main server: " + vendorErrors[0], alertType: "warning" };
        this.props.liftGlobalState({ name: 'notifications' }, notifications);
      }
      else if (!results) {
        setTimeout(() => document.getElementById("logout-button").click(), 10);
      } else {
        // stop animation
        if (Object.keys(results).length == 0 ||
          // !results[requiredKey] || 
          (exceptions && Object.keys(exceptions).length != 0)) {
          let errorM = '';
          if (exceptions && Object.keys(exceptions).length != 0) {
            errorM = exceptions.message && exceptions.message.indexOf('Exception') != -1 ? `Error Occured in ${label}` : exceptions.message;
          }

          this.setErrorMessages(errorM);
          alerts.unshift({ value: "Error Occured", alertType: "warning" });
          for (var key in displayData) {
            this.props.liftState({ "name": displayData[key] }, '');
          }
        } else {
          console.log({ displayData });
          for (var key in displayData) {
            this.props.liftState({ "name": displayData[key] }, results[key]);
          }

          // this.props.liftState({ name: "sys_checkbox_close_account" }, false);

          this.props.liftGlobalState({ name: "alerts" }, []);

          // 
          if (onLeave) {
            let ol = [onLeave];
            if (onLeave instanceof Array) {
              ol = onLeave;
            }
            for (var i = 0; i < ol.length; i++) {
              let { action, target, label, value } = ol[i];
              if (action == 'calculateInterest') {
                calculateInterest({ current: this, intOnly: false });
              }
              if (action == 'selectList') {
                let allOpts = [];
                for (var i = 0; i < results.hits.length; i++) {
                  let res = results.hits[i];
                  let lb = getObjectsValue(res, label);
                  if (lb) {
                    allOpts.push({ label: lb, value: getObjectsValue(res, value), data: res });
                  }
                }
                this.props.liftGlobalState({ name: target }, allOpts);
              }
            }
          }
        }
        this.props.liftGlobalState({ name: 'notifications' }, []);
      }
    }
    else if (!e.target.checked && clearData) {
      clearData.map(c => this.props.liftState({ name: c }, ''));
    }
  }

  componentDidMount() {
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData, defaultValue } = this.props.component;
    if (
      pageData && !fileFolder.isOpen &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      this.props.component.default
    ) {
      this.props.liftState(this.props.component, this.props.component.default);
    }
  }

  render() {
    const { name, label, description, title, isReadOnly, star, icon, insertonly, style, next_field, hidden } = this.props.component;
    let { currentPage, fileFolder, formState, openmodals, pageData, LocalVars, errorMessages } = this.props.parentState;
    let { conditionalRender } = this.props;
    let isReadOnly1 = false;
    if ((pageData.unique_id && isReadOnly == 'edit') || (conditionalRender && conditionalRender == 'readonly') || (isReadOnly && isReadOnly != 'edit')) {
      isReadOnly1 = true;
    }
    let boxvalue;
    let modalname = openmodals[openmodals.length - 1];
    if (modalname && pageData[modalname]) {
      boxvalue = pageData[modalname][name]
        ? pageData[modalname][name]
        : false;
    } else {
      boxvalue = pageData[name]
        ? pageData[name]
        : false;
    }
    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();
    let { compressed, ShowHistory } = LocalVars;
    let currentError
    if (errorMessages) {
      if (modalname && errorMessages[modalname] && errorMessages[modalname][name]) {
        currentError = errorMessages[modalname][name];
      } else if (!modalname && errorMessages[name]) {
        currentError = errorMessages[name];
      }
    }
    let x;
    (icon && !icon.style) ? icon.style = {} : x = 0;
    // console.log(this.props.parentState)
    if (insertonly && !ShowHistory) {
      isReadOnly1 = true;
    }
    return (
      <div
        style={{ paddingLeft: 30, ...style }}
        className={`form-group form-check  ${this.props.component.widths.parent
          } ${compressed ? "checkbox-compressed" : ""}`}
      >
        {title && (
          <span>
            {title} <br />
          </span>
        )}{" "}

        {conditionalRender && conditionalRender != 'blank' &&
          <label style={{ color: isReadOnly1 ? "gray" : "black" }}
            className={`hand ${isReadOnly1 ? 'readonly' : ""} form-check-label ${compressed ? "nopadding" : ""} `}
          // style={{ paddingTop: 5 }}
          >
            {!isReadOnly1 && !hidden &&
              <input
                type="checkbox"
                className={` form-check-input ${currentError
                  ? "checkboxcss"
                  : ""
                  } `}

                style={{ float: "left" }}
                name={name}
                checked={boxvalue ? true : false}
                onChange={this.handleChange}
                onKeyDown={(e) => goToName(e, next_field, name, this)}

              />
            }

            {star && <span style={{ color: "#990000" }}>*</span>}

            {!star && !hidden && <span style={style}>{label}</span>}

            {/* {star &&
              (<div className="row" style={{ float: "left" }}> <div className="col-sm-10">{label}</div> <div className="col-sm-1 nopadding"><span style={{ color: "#990000" }}>*</span></div>  </div>)
            }

            {!star &&
              <div style={{ float: "left" }}>{label}</div>
            } */}
            {icon && <RelevantIcon icon={icon.icon} style={{ ...icon.style, fontSize: 20, float: "left" }} />}

          </label>
        }
      </div>
    );
  }
}

export default CheckboxCustom;
